export default {
  hero: {
    title: 'Về Chúng Tôi',
    subtitle: 'The Daeg International Trade - Đối Tác Tin Cậy Của Bạn',
  },
  intro: {
    title: 'Về The Daeg International Trade',
    description1: 'Là công ty hàng đầu chuyên cung cấp về Dịch vụ Tư vấn Đầu Tư Định Cư Latvia, ngoài ra chúng tôi còn cung cấp thêm các dịch vụ về xuất nhập khẩu. Với hơn 5 năm kinh nghiệm, chúng tôi đã giúp hàng trăm khách hàng thành công trong việc mở rộng kinh doanh và đạt được mục tiêu đầu tư.',
    description2: 'Chúng tôi chuyên cung cấp giải pháp toàn diện từ nhập khẩu hàng Á Châu sang Châu Âu, tư vấn đầu tư định cư Latvia, đến vận hành chuỗi siêu thị Asian Alley - cầu nối văn hóa Á Châu với thị trường Châu Âu.',
  },
  values: {
    title: 'Giá Trị Cốt Lõi',
    subtitle: 'Những giá trị định hướng mọi hoạt động của chúng tôi',
    items: [
      {
        title: 'Chính Trực',
        description: 'Chúng tôi luôn đặt sự trung thực và minh bạch lên hàng đầu trong mọi giao dịch',
      },
      {
        title: 'Tận Tâm',
        description: 'Tận tâm phục vụ và đồng hành cùng khách hàng trong suốt hành trình',
      },
      {
        title: 'Chuyên Nghiệp',
        description: 'Quy trình làm việc chuyên nghiệp với đội ngũ chuyên gia giàu kinh nghiệm',
      },
      {
        title: 'Hiệu Quả',
        description: 'Tập trung vào kết quả thực tế và giá trị bền vững cho khách hàng',
      },
    ],
  },
  asianAlley: {
    title: 'Asian Alley - Niềm Tự Hào Của Chúng Tôi',
    description: 'Asian Alley là chuỗi siêu thị Á Châu của chúng tôi tại Latvia, nơi chúng tôi mang đến những sản phẩm Á Châu chất lượng cho cộng đồng Châu Âu. Đây không chỉ là một doanh nghiệp mà còn là cầu nối văn hóa và tạo cơ hội kinh doanh cho các đối tác.',
    stats: [
      {
        value: '2',
        label: 'Cơ Sở',
      },
      {
        value: '€500K+',
        label: 'Doanh Thu/Năm',
      },
      {
        value: 'Hàng Nghìn',
        label: 'Khách Hàng',
      },
    ],
  },
  cta: {
    title: 'Sẵn Sàng Bắt Đầu?',
    description: 'Liên hệ với chúng tôi ngay hôm nay để được tư vấn miễn phí về giải pháp xuất nhập khẩu và đầu tư định cư Latvia.',
    phone: 'Hotline',
    email: 'Email',
    emailNote: 'Phản hồi trong 24 giờ',
    address: 'Địa Chỉ',
    addressValue: 'Riga, Latvia',
    button: 'Liên Hệ Ngay',
  },
} as const;